<template>
  <div>
    <div style="margin-top: 30px;">
      <h1 style="display: inline">{{ $t("booking.budgetUtilization") }}</h1>
    </div>
    <booking-menu />
    <v-row>
      <v-spacer />
      <v-btn class="mr-0" color="primary" @click="clearDefaults">{{ $t("booking.clearBudget") }}</v-btn>
      <v-btn class="ml-0" color="success" to="/booking/report/budget/new">{{ $t("booking.addBudget") }}</v-btn>
    </v-row>
    <v-data-table :items="items" :headers="headers">
      <template #item="props">
        <tr>
          <td>
            <h3>
              {{ props.item.name }}
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="success" v-if="props.item.is_default">attach_money</v-icon>
                </template>
                {{ $t("booking.defaultBudget") }}
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="primary" v-if="props.item.is_flight_default">flight</v-icon>
                </template>
                {{ $t("booking.flightBudget") }}
              </v-tooltip>
            </h3>
          </td>
          <td>{{ props.item.start_date }}</td>
          <td>{{ props.item.end_date }}</td>
          <td>{{ serviceTypesNames.find(v => v.value === props.item.service_type_group).text }}</td>
          <td>{{ props.item.amount }}</td>
          <td>{{ fieldTypesNames.find(v => v.value === props.item.calculate_by_field).text }}</td>
          <td>
            <span style="font-weight: bold">{{ props.item.utilization }}/{{ props.item.amount }}</span>
          </td>
          <td style="min-width: 150px;">
            <v-progress-linear
              :value="percentageUtilization(props.item)"
              :color="percentageUtilization(props.item) > 100 ? 'error' : 'success'"
              height="12"
              width="50px"
              style="margin: 3px 5px 0;width: 100px; display: inline-block"
            />
            <span :class="percentageUtilization(props.item) > 100 ? 'error--text' : 'success--text'">
              {{ ((props.item.utilization / props.item.amount) * 100).toFixed(2) }} %</span
            >
          </td>
          <td>
            <v-menu offset-y style="display: inline">
              <template v-slot:activator="{ on: menu }">
                <v-tooltip top>
                  <template v-slot:activator="{ on: tooltip }">
                    <v-btn icon v-on="{ ...tooltip, ...menu }"><v-icon>featured_play_list</v-icon></v-btn>
                  </template>
                  {{ $t("booking.setShowBudget") }}
                </v-tooltip>
              </template>
              <v-list>
                <v-list-item @click="setAsDefault(props.item.id)">
                  <v-list-item-title>
                    {{ $t("booking.defaultBudget") }}
                  </v-list-item-title>
                </v-list-item>
                <v-list-item @click="setAsFlightDefault(props.item.id)">
                  <v-list-item-title>
                    {{ $t("booking.flightBudget") }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-tooltip top>
              <template #activator="{on}">
                <v-btn v-on="on" icon @click="$router.push('/booking/report/budget/edit/' + props.item.id)"><v-icon>edit</v-icon></v-btn>
              </template>
              {{ $t("global.edit") }}
            </v-tooltip>
            <v-tooltip top>
              <template #activator="{on}">
                <v-btn v-on="on" icon @click="remove(props.item.id)"><v-icon>delete</v-icon></v-btn>
              </template>
              {{ $t("global.delete") }}
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { serviceTypesNames, fieldTypesNames } from "../../../staticData/Budget";
import BookingMenu from "../../../components/Booking/BookingMenu";
export default {
  name: "BookingReportBudgetUtilizationView",
  components: { BookingMenu },
  data: () => ({
    items: []
  }),
  methods: {
    setAsDefault(id) {
      this.axios.post("booking/budget/set-default-utilization", { id: id }).then(() => {
        this.downloadUtilization();
        this.$store.dispatch("snackbarPush", {
          text: this.$t("global.saved"),
          position: "down"
        });
      });
    },
    setAsFlightDefault(id) {
      this.axios.post("booking/budget/set-flight-utilization", { id: id }).then(() => {
        this.downloadUtilization();
        this.$store.dispatch("snackbarPush", {
          text: this.$t("global.saved"),
          position: "down"
        });
      });
    },
    percentageUtilization(item) {
      return ((item.utilization / item.amount) * 100).toFixed(2);
    },
    downloadUtilization() {
      this.axios.get("/booking/budget/get-utilization").then(resp => {
        this.items = resp.data;
      });
    },
    remove(id) {
      let dialog = this.$store.dispatch("confirmDialog", {
        content: this.$t("global.removeConfirm.content"),
        title: this.$t("global.removeConfirm.title")
      });
      dialog.then(() => {
        this.axios.post("booking/budget/remove", { id: id }).then(() => {
          this.downloadUtilization();
          this.$store.dispatch("snackbarPush", {
            text: this.$t("global.deleted"),
            position: "down"
          });
        });
      });
    },
    clearDefaults() {
      this.axios.post("booking/budget/clear-defaults").then(() => {
        this.downloadUtilization();
        this.$store.dispatch("snackbarPush", {
          text: this.$t("global.saved"),
          position: "down"
        });
      });
    }
  },
  computed: {
    serviceTypesNames,
    fieldTypesNames,
    headers() {
      return [
        { text: this.$t("global.name"), value: "name" },
        { text: this.$t("booking.budgetStartDate"), value: "start_date" },
        { text: this.$t("booking.budgetEndDate"), value: "end_date" },
        { text: this.$t("booking.serviceTypeGroups"), sortable: false },
        { text: this.$t("booking.amount"), value: "amount" },
        { text: this.$t("global.type"), sortable: false },
        { text: this.$t("booking.budgetUtilization"), sortable: false },
        { text: "", sortable: false },
        { text: "", sortable: false }
      ];
    }
  },
  created() {
    this.downloadUtilization();
  }
};
</script>

<style scoped></style>
